import { createClient } from 'contentful'

let contentfulClient = createClient({
    space: '3xcw76fxn9of',
    accessToken: '8RDPor1WHRpgEQFU8I44CVNAYUk8xo3hkT5a2jQb6r4'
});


export default contentfulClient;